<template>
    <swiper :options="swiperOption" :key="JSON.stringify(items)">
        <swiper-slide v-for="(item, index) in items" :key="index">
            <slot :item="item" />
        </swiper-slide>
        <div :class="['swiper-pagination', {'swiper-pagination-white': isLight}]" slot="pagination"></div>
        <template>
            <div :class="['swiper-button-prev', {'swiper-button-white': isLight}, {'swiper-button-hidden': isLessThanFiveItems}]" slot="button-prev"></div>
            <div :class="['swiper-button-next', {'swiper-button-white': isLight}, {'swiper-button-hidden': isLessThanFiveItems}]" slot="button-next"></div>
        </template>
    </swiper>
</template>

<script>
    import { swiper, swiperSlide } from 'vue-awesome-swiper'

    require('swiper/dist/css/swiper.css')

    export default {
        components: {
            swiper,
            swiperSlide
        },
        props: {
            items: Array,
            lightTheme: {
                type: Boolean,
                default: true,
            },
            theme: {
                type: String,
                default: 'light',
                validator: (prop) => ['light', 'dark'].includes(prop)
            }
        },
        computed: {
            isLight () {
                return this.theme === 'light'
            },
            slidesPerView () {
                return this.$mq.includes('desktop_l') ? 3 : 4
            },
            swiperOption () {
                return {
                    slidesPerView: this.slidesPerView,
                    slidesPerGroup: 3,
                    spaceBetween: 30,
                    pagination: this.items.length > 4 ? {
                        el: '.swiper-pagination',
                        clickable: true
                    } : false,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            },
            isLessThanFiveItems () {
                return this.items.length < 5
            }
        }
    }
</script>

<style lang="scss">
    .swiper-button-prev,
    .swiper-button-next {
        top: auto;
        bottom: 0;
        background: none;
        font-family: 'icomoon' !important;
        display: flex;
        align-items: center;
        font-size: 3.7rem;

        &.swiper-button-white {
            background: none;
            color: $white;
        }

        &:focus {
            outline: none;
        }
    }

    .swiper-button-hidden {
        display: none;
    }

    .swiper-wrapper {
        width: calc(100% - 15px)
    }

    .swiper-container-horizontal {
        & > .swiper-pagination-bullets {
            width: auto;
            left: 60px;
            right: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .swiper-button-next {
        &:before {
            content: "\e935";
        }
    }

    .swiper-button-prev {
        &:before {
            content: "\e936";
        }
    }

    .swiper-pagination-bullet-active {
        background: $orange;
        width: 16px !important;
        height: 16px !important;
    }

    .swiper-pagination-bullet {
        width: 10px;
        height: 10px;
        margin: 0 10px !important;
    }

    .swiper-slide {
        height: unset;
    }
</style>
